import { useState } from 'react';
import { TinhThanh } from '@/types/schemas/tinh-thanh.type';
import { BoPhan } from '@/types/schemas/bo-phan.type';
import { NhanVien } from '@/types/schemas';

/**
 * Hook for managing search field states in the nhan-vien feature
 *
 * @param initialData - Initial nhan-vien data (optional)
 * @returns Object with states and setters for search fields
 */
export const useSearchFieldStates = (initialData?: NhanVien) => {
  // Department state
  const [department, setDepartment] = useState<BoPhan | null>(initialData?.ma_bo_phan_data || null);

  // Location state
  const [location, setLocation] = useState<TinhThanh | null>(initialData?.noi_cap_cmnd_data || null);

  return {
    department,
    setDepartment,
    location,
    setLocation
  };
};
